import React from 'react'
import { useTranslation } from 'react-i18next'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { getFullscreenPortalContainer } from 'src/mtska-frontend-app-component/utils/fullscreenPortalContainer'

const DateAfterBeforeFilterElement = ({ label, operator, value, handleValueChange, setFocused }) => {
    const { t } = useTranslation()

    const isValueEmpty = value === '' || value === null || value === undefined;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                format="DD/MM/YYYY"
                label={label ? t(label) : t(operator)}
                onAccept={(value) => {
                    const safeValue = value ? value.format('YYYY-MM-DD') : null;
                    handleValueChange(safeValue);
                }}
                slotProps={{
                    textField: {
                        placeholder: '',
                        variant: 'filled',
                        sx: { width: '100%' },
                        onFocus: (e) => {
                            const button = e.target
                                .closest('.MuiInputBase-root')
                                ?.querySelector('.MuiInputAdornment-root button');
                            button?.click();
                        }
                    },
                    actionBar: {
                        className: 'mtska-date-range',
                        actions: ['clear']
                    },
                    popper: {
                        onClickAway: () => console.info('Click outside'),
                        container: getFullscreenPortalContainer,
                    },
                    desktopPaper: {
                        onMouseLeave: () => console.info('Click outside')
                    }
                }}
                openOnFocus
                value={dayjs(value ?? null)}
                className="form-element filter-element form-element-date"
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}

                InputProps={!isValueEmpty && {
                    startAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                sx={{ padding: '4px' }}
                                onClick={() => handleValueChange({ from: null, to: null })}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </LocalizationProvider>
    )
}

export default DateAfterBeforeFilterElement;